import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-539a7ecd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "notice-list" }
const _hoisted_2 = {
  key: 0,
  style: {"height":"calc(100% - 0.82rem)","overflow":"auto"}
}
const _hoisted_3 = { class: "pagination" }

import NoticeItem from "@/views/member/notice/components/NoticeItem.vue";
import {ref} from "vue";
import settings from "@/utils/settings";
import {queryMessageListApi} from "@/api/message";

interface props {
  tabName: string  // 选中的标签
}

interface page {
  page: number,
  limit: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NoticeList',
  props: {
    tabName: {}
  },
  setup(__props: any) {

const props = __props

console.log(props.tabName, 'tabName');

/**
 * 消息列表
 */
const noticeList = ref<any>([]);

/**
 * 翻页
 */
const page = ref<page>({
  page: 1,
  limit: 10
});

const {pageSizes} = settings;

/**
 * 总条数
 */
const total = ref<number>(0);

const loading = ref(false);

/**
 * 获取消息列表
 */
const getMessageList = async () => {
  loading.value = true;
  const data: any = await queryMessageListApi({
    ...page.value,
    ...{
      type: props.tabName
    }
  })
  loading.value = false;
  total.value = data.total || 0;
  noticeList.value = data.data;
}
getMessageList();

return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (noticeList.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noticeList.value, (item) => {
            return (_openBlock(), _createBlock(NoticeItem, {
              key: item.id,
              data: item
            }, null, 8, ["data"]))
          }), 128))
        ]))
      : (_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          style: {"height":"calc(100% - 0.82rem)"}
        })),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_pagination, {
        "current-page": page.value.page,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((page.value.page) = $event)),
        "page-size": page.value.limit,
        "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((page.value.limit) = $event)),
        "page-sizes": _unref(pageSizes),
        background: "",
        layout: "total, prev, pager, next, jumper",
        total: total.value,
        "hide-on-single-page": true,
        onCurrentChange: getMessageList
      }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
    ])
  ]))
}
}

})